import React from 'react';

import ProductNavigation from '../containers/ProductNavigation';
import CategoriesList from '../containers/CategoriesList';
import BrandsList from '../containers/BrandsList';
import ProductList from '../containers/ProductList';
import ProductSearchInput from '../containers/ProductSearchInput';

const Products = () => (
  <div>
    <ProductNavigation />
    <div className="u-mv">
      <ProductSearchInput />
    </div>
    <div className="u-mt">
      <CategoriesList />
    </div>
    <div className="u-mt">
      <BrandsList />
    </div>
    <div className="u-mt">
      <ProductList />
    </div>
  </div>
);

export default Products;
